import { Trans } from '@lingui/react/macro';
import { TApplication } from 'lendingApi/applications.types';
import styles from './Funded.module.css';
import { useFunded } from './useFunded.hook';

type TProps = {
  application: TApplication;
  showCommission: boolean;
};

export const Funded = ({ application, showCommission = false }: TProps) => {
  const { hasCommission, totalDrawdownAmount, paidCommission } =
    useFunded(application);

  return (
    <div className={styles.fundedContainer}>
      <div className={styles.funded}>
        <Trans>Funded</Trans>
      </div>
      <div>
        <Trans>Withdrawn: {totalDrawdownAmount}</Trans>
      </div>
      {hasCommission && showCommission && (
        <div>
          <Trans>Commission: {paidCommission}</Trans>
        </div>
      )}
    </div>
  );
};
